webpackJsonp([445],{

/***/ 1721:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(906),
  /* template */
  __webpack_require__(2194),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/document-framework-14.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] document-framework-14.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-43b750ec", Component.options)
  } else {
    hotAPI.reload("data-v-43b750ec", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2194:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("文档是用什么工具编写的？")]), _vm._v(" "), _c('p', [_vm._v("早期版本使用的是 "), _c('a', {
    attrs: {
      "href": "https://docute.js.org"
    }
  }, [_vm._v("Docute")]), _vm._v(" by "), _c('a', {
    attrs: {
      "href": "https://github.com/egoist"
    }
  }, [_vm._v("egoist")]), _vm._v("。在"), _c('code', [_vm._v("Docute")]), _vm._v("基础上做了一点样式修改。")]), _vm._v(" "), _c('p', [_vm._v("2.2.1 后面版本出于 "), _c('code', [_vm._v("SEO")]), _vm._v(" 考虑使用 "), _c('code', [_vm._v("Vue")]), _vm._v(" 的服务端渲染，使用的框架同样是 "), _c('a', {
    attrs: {
      "href": "https://github.com/egoist"
    }
  }, [_vm._v("egoist")]), _vm._v(" 开发的 "), _c('a', {
    attrs: {
      "href": "https://github.com/ream/ream"
    }
  }, [_vm._v("ream")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("文档部分样式参照了 "), _c('a', {
    attrs: {
      "href": "https://eggjs.org/"
    }
  }, [_vm._v("eggjs.org")]), _vm._v("，表示感谢。")]), _vm._v(" "), _c('p', [_vm._v("因此目前无论是组件还是文档都是完全基于 "), _c('code', [_vm._v("Vue")]), _vm._v("，cool right?")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-43b750ec", module.exports)
  }
}

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1721);

/***/ }),

/***/ 906:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "文档是用什么工具编写的？ | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 445.7125b50a.js